import alertConstants from "../constants/alertConstants";

const notice = (message, altType) => {
  return { type: alertConstants.NOTICE, message, altType: altType };
};

function success(message, altType) {
  //console.log(message, altType);
  return { type: alertConstants.SUCCESS, message, altType: altType };
}

function error(message, altType) {
  return { type: alertConstants.ERROR, message, altType: altType };
}

function clear() {
  return { type: alertConstants.CLEAR };
}

const alertActions = {
  success,
  error,
  clear,
  notice,
};

export default alertActions;
